import { render } from "./WeakPerfomancePractitioner.vue?vue&type=template&id=a0d6a032"
import script from "./WeakPerfomancePractitioner.vue?vue&type=script&lang=js"
export * from "./WeakPerfomancePractitioner.vue?vue&type=script&lang=js"

import exportComponent from "/usr/src/nuxt-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__